export const emptyFeatureFlags: FeatureFlags = {
  internal_administrator: false,
  hummer: false,
  pipeline_review_ai_digest: false,
};

export type FeatureFlags = {
  internal_administrator: boolean;
  hummer: boolean;
  pipeline_review_ai_digest: boolean;
};
